/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-23 16:32:51
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\antiFake\fleeWarning.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 溯源管理列表数据查询或查询溯源列表客户查询/产品查询内层UDI
export function getFleeWarningList(params) {
  return request({
    url: '/appletAntifake/list',
    method: 'get',
    params,
    headers: {
      isApplet: true
    }
  })
}

// 处理窜货预警
export function saveOrUpdateFleeWarning(params) {
  return request({
    url: '/appletAntifake/saveHandle',
    method: 'post',
    params,
    headers: {
      isApplet: true
    }
  })
}

export function getFleeWarning(params) {
  return request({
    url: '/appletAntifake/getRecord',
    method: 'get',
    params,
    headers: {
      isApplet: true
    }
  })
}
